import progressBar from '../../../shared/DOM/progressBar.js';
import { executeEnrollmentStep } from '../api/executeEnrollmentStep.js';
import { checkShowErrorOtp } from './checkShowErrorOtp.js';

/**
 * Enrollment go to step
 *
 * @param {*} tokena
 * @param {*} user
 * @param {*} stepNum
 * @param {*} stepData
 * @param {*} _step
 * @returns
 */
export async function executeStep(tokena, user, stepNum, stepData) {
  try {
    progressBar.loading();
    const ediwinResult = await executeEnrollmentStep(tokena, user, stepNum, stepData);
    if (!ediwinResult?.result) {
      const message = ediwinResult?.errors?.join('\n') || ediwinResult?.message || 'global.error-occurred';
      throw new Error(message);
    } else {
      progressBar.resolved();
      return ediwinResult;
    }
  } catch (error) {
    progressBar.rejected();
    checkShowErrorOtp(error);
    throw error;
  }
}
